import { useState } from 'react';
import { Snackbar } from '@andes/snackbar';


export type SnackBarProps = {
  message: string,
  type: 'success' | 'error',
  delay?: number,
}
export const typeColor: Record<string, 'green' | 'red'> = {
  success: 'green',
  error: 'red',
};

/* istanbul ignore next */
export const useSnackbar = (props: SnackBarProps) => {
  const [show, setShow] = useState(false);
  const [message, setMessage] = useState(props.message);
  const [color, setColor] = useState(typeColor[props.type]);
  const { delay = 20000 } = props;

  const snackbar = (
    <Snackbar
      message={message}
      color={color}
      delay={delay}
      show={show}
      onChange={setShow}
    />
  );

  return {
    show,
    setShow,
    snackbar,
    setMessage,
    setColor,
  };
};

